module.exports = __webpack_public_path__ + "static/media/popup-invite-ribbon.15235127.png";